import {OrderGrid} from "./order/OrderGrid";
import {Button, Input} from "reactstrap";
import {useEffect, useRef, useState} from "react";
import {OrderSearchCriteriaPanel} from "./order/OrderSearchCriteriaPanel";
import {Link} from "react-router-dom";
import './AdminHome.css';
import {useAppDispatch, useAppSelector, useClaims} from "../../app/hooks";
import {fetchMoreOrders, fetchOrders, selectOrderSearchCriteria, selectOrderSearchSortState} from "../order/OrderSlice";
import { SortState } from "../../utils/Grid";
import {OrderVm} from "../order/Order";

export const AdminHome = () => {
    const {hasEditingRole} = useClaims();
    const dispatch = useAppDispatch();
    
    const orderSearchCriteria = useAppSelector(selectOrderSearchCriteria);
    const sortRef = useRef<SortState<OrderVm>>({
        column: 'timeCreated',
        serverColumn: 'o.TimeCreated',
        direction: 'desc',
    });
    
    const [search, setSearch] = useState('');
    const [criteriaIsOpen, setCriteriaIsOpen] = useState(true);

    const ToolRow = () => (
        <div className='d-flex flex-row-reverse mb-3'>
            <Input
                className='w-50 mx-1 ms-auto'
                placeholder='Filter results by text...'
                defaultValue={search}
                onChange={e => setSearch(e.target.value)}/>
            {hasEditingRole &&
                <Link className='btn btn-primary mx-1'
                      to='order/new'>
                    Create New Order
                </Link>
            }
            <Button color='secondary' 
                    className='criteria-button btn-secondary'
                    outline={true}
                    onClick={() => setCriteriaIsOpen(old => !old)}>
                {criteriaIsOpen ? 'Close' : 'Open'} Search Criteria
            </Button>
        </div>
    );

    function executeSearch() {
        console.log('executeSearch', orderSearchCriteria, sortRef.current);
        
        dispatch(fetchOrders({
            criteria: orderSearchCriteria,
            paging: {
                sortDirection: sortRef.current.direction,
                sortKey: sortRef.current.serverColumn ?? sortRef.current.column
            }
        }));
    }
    
    function handleSearchClick() {
        executeSearch();
    }

    function handleOnSortChange(sortState: SortState<OrderVm>) {
        sortRef.current = sortState;
        executeSearch();
    }

    function handleShouldLoadMore(cursor: any) {
        console.log('cursor', cursor);
        dispatch(fetchMoreOrders({
            criteria: orderSearchCriteria,
            paging: {
                sortDirection: sortRef.current.direction,
                sortKey: sortRef.current.serverColumn ?? sortRef.current.column,
                ...cursor
            }
        }))
    }

    function handleRefreshClick() {
        executeSearch();
    }

    return (
        <div className='d-flex justify-content-between w-100 h-100'>
            <div className={'d-flex flex-column grid-criteria-container mx-2'}>
                <OrderSearchCriteriaPanel isOpen={criteriaIsOpen}
                                          onSearchClick={handleSearchClick}
                />
            </div>
            <div className='d-flex flex-column admin-home-right-side-content'>
                {ToolRow()}
                <OrderGrid search={search.toLowerCase()}
                           onSortChange={handleOnSortChange}
                           onShouldLoadMoreOrders={handleShouldLoadMore}
                           onRefreshClick={handleRefreshClick}
                />
            </div>
        </div>
    );
}